// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3STp9","col":"styles_col__1HuUr"};